import Search from "./components/search";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <h1>Weather App</h1>
      <Search />
      <a href="https://github.com/Farimah71/Weather-App-React.git">
        <small>Github link</small>
      </a>
    </div>
  );
}
